__turbopack_context__.v({
  "inner": "scrollbar-module__c0JzOq__inner",
  "scrollbar": "scrollbar-module__c0JzOq__scrollbar",
  "thumb": "scrollbar-module__c0JzOq__thumb",
});
